<template>
  <div class="content">
    <div>
      <h3>Список маршрутов в АТИ</h3>
    </div>
    <my-loader v-if="loading"></my-loader>
    <table v-if="routes" class="company-table">
      <thead>
        <tr>
          <th>Маршрут</th>
          <th>Погрузка</th>
          <th>Выгрузка</th>
          <th>Цена с НДС</th>
          <th>Цена без НДС</th>
          <th>Удалить из АТИ</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="route in routes" :key="route.id">
          <td>{{ route.city_in }}-{{ route.city_out }}</td>
          <td>{{ formatData(route.first_dt)}}</td>
          <td>{{ formatData(route.last_dt)}}</td>
          <td>{{ route.price_nds }}</td>
          <td>{{ route.price }}</td>
          <td><button class="delete-button bg-denied hover" @click="deleteRoute(route.id)">Удалить</button></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { onMounted, computed } from 'vue';
import { useStore } from 'vuex';

export default {
  setup() {
    const store = useStore()
    
    onMounted(()=>{
      store.dispatch('ati/getMyRoutes')
    })

    const formatData = (data) =>{
        if(!data){
            return ''
        }
        return data.split('T')[0]
    }

    const deleteRoute = (id) =>{
      store.dispatch('ati/deleteFromAti',{id})
    }

    return {
      loading:computed(()=>store.state.ati.loading),
      routes:computed(()=>store.state.ati.myRoutes),
      formatData,
      deleteRoute,
    };
  },
}
</script>

<style scoped>
.content{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.company-table {
  margin-top: 23px;
  margin-left: 20px;
  border-collapse: collapse;
}

.company-table th,
.company-table td {
  text-align: center;
  padding: 10px;
  border: 1px solid #ccc;
}

.company-table th {
  font-weight: bold;
}

h3 {
  margin-top: 20px;
  text-align: center;
}

.delete-button{
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #ccc;
  color: white;
}
</style>
